import {useAttendee} from 'Event/auth'
import {ImageMasonryWall, useFetchEntries} from 'Event/ImageWaterfall'
import Page, {
  BackToDashboardLink,
  PageTitle,
  PageDescription,
} from 'Event/template/Townhall/Page'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'
import React from 'react'
import TextContent from 'lib/ui/form/TextEditor/Content'
import {useAttendeeVariables} from 'Event'
import {eventRoutes} from 'Event/Routes'
import {useTownhallTemplate} from 'Event/template/Townhall'

export default function TownhallImageWaterfall() {
  const user = useAttendee()
  const {loading, entries} = useFetchEntries()
  const {imageWaterfall: pageSettings} = useTownhallTemplate()
  const v = useAttendeeVariables()

  if (loading) {
    return <FullPageLoader />
  }

  return (
    <Page user={user}>
      <PageTitle>{v(pageSettings.title)}</PageTitle>
      <PageDescription description={v(pageSettings?.description)}>
        <TextContent>{v(pageSettings?.description)}</TextContent>
      </PageDescription>
      <BackToDashboardLink
        color={pageSettings.backToDashboardTextColor}
        to={eventRoutes.root}
      >
        {v(pageSettings.backToDashboardText)}
      </BackToDashboardLink>
      <ImageMasonryWall entries={entries} />
    </Page>
  )
}
